import { defineComponent as _defineComponent } from 'vue'
import FormContainer from "../shared/FormContainer.vue"
import { PropType, ref } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"
import { useUtilities } from "@/hooks/useUtilities"
import { ValidationObserver } from "vee-validate"
import { useNotification } from "@/hooks/useNotification"
import Modal from "@/components/widgets/common/Modal.vue"
import { useNewConsultantInputForm } from "../shared/useNewConsultantInputForm"

type EducationForm = {
  id?: string
  name: string
  degree: string
  institutionName: string
  startDate: string
  endDate: string
  grade: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EducationInfoForm',
  props: {
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  submitButtonText: {
    type: String,
    default: "Done",
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
      iconColor: THEMES.PERALTA_PRIMARY_RED,
    }),
    required: false,
  },
},
  emits: ["gotoNext", "gotoPrev", "change"],
  setup(__props, { emit }) {




const { formatDate, generateRand } = useUtilities()
const { addError } = useNotification()
const { updateNewConsultantInput } = useNewConsultantInputForm()

const defaultForm: EducationForm = {
  name: "",
  degree: "",
  institutionName: "",
  startDate: "",
  endDate: "",
  grade: "",
}

const form = ref<EducationForm>({
  ...defaultForm,
})

const educationList = ref<EducationForm[]>([])

const observer = ref<InstanceType<typeof ValidationObserver> | null>(null)

const showAddEducationDialog = ref(false)

const onClose = () => {
  showAddEducationDialog.value = false
  resetForm()
}

const onAddEducation = () => {
  showAddEducationDialog.value = true
}

const onSaveEducation = () => {
  const formValues = { ...form.value }

  if (formValues.id) {
    const index = educationList.value.findIndex((education) => education.id === formValues.id)
    if (index !== -1) {
      educationList.value[index] = formValues
    }
  } else {
    educationList.value.push({ ...formValues, id: generateRand(10) })
  }

  updateNewConsultantInput({
    consultantEducationsAttributes: educationList.value.map((education) => ({
      ...education,
      id: undefined,
    })),
  })

  showAddEducationDialog.value = false

  emit("change", educationList.value)
  resetForm()
}

const onEditEducation = (education: EducationForm) => {
  showAddEducationDialog.value = true
  form.value = {
    ...education,
  }
}

const onSubmit = async () => {
  const validity = await (observer.value as any)?.validateWithInfo()
  if (!validity.isValid) return
  onSaveEducation()
}

const gotToNext = () => {
  const payload = educationList.value.map(({ id, ...education }) => ({
    ...education,
  }))

  if (educationList.value.length < 1) {
    addError("At least one education is required")
  } else {
    emit("change", payload)
    emit("gotoNext")
  }
}

const resetForm = () => {
  form.value = {
    ...defaultForm,
  }
  observer.value?.reset()
}

return { __sfc: true,emit, formatDate, generateRand, addError, updateNewConsultantInput, defaultForm, form, educationList, observer, showAddEducationDialog, onClose, onAddEducation, onSaveEducation, onEditEducation, onSubmit, gotToNext, resetForm, FormContainer, ValidationObserver, Modal }
}

})